import React, { useEffect } from 'react';
import { useBeta } from '../BetaGate';
import './skin.css';

/**
 * Gives a current screen the new pages' look without changing its code (Joseph, 27 Oct: Deal rooms
 * and Extraction review, same functionality, new font and colors). See skin.css.
 *
 * <Skin page> wraps a whole route: the look applies to beta users only, to the page's content
 * (not the side menu or top bar) and to its pop-up windows. Everyone else sees the page as before.
 * <Skin> wraps part of a new page (the listing page's tabs), which is already beta.
 */
export default function Skin({ page = false, children }) {
  const beta = useBeta();
  const on = page ? !!beta?.staff : true;
  useEffect(() => {
    if (!on) return undefined;
    // Pop-up windows open outside the page, so they follow a class on the body while this is open.
    // A whole page also styles its content area (v2-skin-body); a wrapped part only its pop-ups.
    const names = page ? ['v2-skin-body', 'v2-skin-modals'] : ['v2-skin-modals'];
    document.body.classList.add(...names);
    return () => document.body.classList.remove(...names);
  }, [on, page]);
  if (page) return children;
  return <div className="v2-skin">{children}</div>;
}
